import axios from 'axios';
import urlUtil from './util-url.js';
//import dateUtil from './util-date.js'
import dbtypeUtil from './util-dbtype.js';
import _ from 'underscore';

/**
	Функции для сабмита форм. В одном месте чтобы не было дублирования для сохранения из списка и карточки

	Описание
	https://wiki.oooinex.ru/pages/viewpage.action?pageId=47743060

	Сваггер
	http://localhost:20000/swagger-ui.html
*/
export default {
	mixin: {
		methods: {
			formdataUtil_doSubmit,
			formdataUtil_getFormData, // создание и получение объекта формы
			formdataUtil_checkFieldList, // Опрашиваем контролы на валидность и возвращаем true если всё ОК
			formdataUtil_getCtrlRef,
			formdataUtil_renderError,
		},
	},
};

/**
 * Метод инстанса Vue, попадает в него через миксин
 * @param {Object}		opt комплексный параметр
 * @param {Number}		opt.armId
 * @param {Array}		opt.fieldList - список полей типа cardMeta или listMeta
 * @param {Function}	opt.successCallback
 * @param {Number}		opt.recordId
 * @param {object}		opt.armState состояние арма
 * @param {string}		opt.armState.actionUrl урл, по которому состоялась правка
 * @param {string}		opt.armState.armPathText путь к записи а-ля хлебные крошки, но другой
 */
function formdataUtil_doSubmit(opt) {
	const vm = this;
	// Опрашиваем контролы на валидность
	if (vm.formdataUtil_checkFieldList(opt.fieldList) === false) {
		return;
	}
	const formData = vm.formdataUtil_getFormData(opt);

	const { specMode } = this.$route.params;
	// !!! по уму надо использовать urlUtil.getServiceUrl()
	let apiUrl = `${urlUtil.getDomain() + urlUtil.getPath({ specMode }) + vm.$route.params.vpId}/${opt.armId}/data`;

	if (opt.hasOwnProperty('showExecutedSql') && opt.showExecutedSql === true) {
		apiUrl += '?showExecutedSql=true';

		if (opt.hasOwnProperty('showExecutedSqlParams') && opt.showExecutedSqlParams === true) {
			apiUrl += '&showExecutedSqlParams=true';
		}
	}

	// Передаем ID родительского арма - PIRS-2-10938
	if (vm.$route.query.parentArmId) {
		apiUrl += `${apiUrl.indexOf('?') > -1 ? '&' : '?'}parent_arm_id=${vm.$route.query.parentArmId}`;
	}

	this.EXT_setRecordSavePending(true); // дисейблим поля записи и что там ещё происходит во время запроса

	// for (var pair of formData.setPayloadAndGetFormData().entries()) {console.log(pair[0] + ' = ' + pair[1]);	} // единственный способ вывода FormData

	axios
		.post(apiUrl, formData.setPayloadAndGetFormData(opt)) // TODO сделать cancelToken как в фильтре, главное чтобы отменялись только запросы сохранения одной сущности!
		.then(function (res) {
			const isOk = res.data && res.data.records && res.data.records.length !== 0;
			if (isOk) {
				// Успех
				opt.successCallback(res);
			} else {
				console.log(res);
				throw Error('Ошибка сабмита');
			}
		})
		.catch(function (thrown) {
			if (opt.errorCallback) {
				opt.errorCallback(thrown);
			}

			const rid = thrown?.response?.data?.rid || thrown?.rid || '<none>';

			// Иногда в режиме попапа эта нотификация не нужна
			if (!opt.notNotify) {
				let notifyText = 'Ошибка отправки данных записи';
				if (rid) {
					notifyText += `<hr/>Идентификатор запроса: ${rid}`;
				}
				vm.$notify({
					type: 'error',
					duration: -1,
					text: notifyText,
				});
			}

			console.log(`RID=${rid}`, thrown);
			console.log(
				`jsonPayload 1st record:\n======================================================\n${JSON.stringify(
					formData.getPayload().records[0],
					null,
					4,
				)}`,
			);
			const triggerError = thrown?.response?.data?.message?.match?.(/TRIGGER_ERROR_BEGIN/) != null;
			const fullTextError = thrown?.response?.data?.message || 'Ошибка отправки данных';
			console.error(fullTextError);
			if (triggerError) {
				const stringErrorStart = fullTextError.indexOf('TRIGGER_ERROR_BEGIN') + 19;
				const stringErrorEnd = fullTextError.indexOf('TRIGGER_ERROR_END');

				const shortTextError = fullTextError.slice(stringErrorStart, stringErrorEnd);
				vm.errText = shortTextError;
			} else {
				vm.errText = fullTextError;
			}
			if (rid) {
				vm.errText += `\nИдентификатор запроса: ${rid}`;
			}
		})
		.then(function () {
			vm.EXT_setRecordSavePending(false); // энейблим поля записи и что там ещё происходит когда запрос кончился
		});
}
/**
 *
 * @param {*} opt
 */
function formdataUtil_getFormData(opt) {
	const { armId, mode, recordId, armState } = opt;
	const formData = new ArmFormData({ armId, mode, recordId, armState });

	// Для сохранения из дочерних АРМ. Если в АРМ нет поля с айди родителя, его нужно будет добавить из opt.parentFieldData
	let needToSetParentField = true;

	for (let i = 0; i < opt.fieldList.length; i++) {
		const field = opt.fieldList[i];

		if (!field) {
			// поля у которых нет контрола в текущем представлении (карточка или список) являются null
			continue;
		}

		const fieldName = field.dbcolname;
		const isFile = field.ctrlCode === 'file_upload';

		if (fieldName.toUpperCase() === 'ID' && !isFile) {
			// поле айди мы не отправляем как поле АРМ, это primaryKeyValue
			// но для поля файл сделано исключение, оно может висеть на ID например в БДММ
			continue;
		}

		const clientDbtype = dbtypeUtil.getClientTypeByDbType(field.dbcoltype); // клиентский синтетический тип
		//var serverDbtype = dbtypeUtil.getServerTypeByDbType(field.dbcoltype); // серверный синтетический тип  https://wiki.oooinex.ru/pages/viewpage.action?pageId=47743062

		// console.log(field.dbcolname, clientDbtype, serverDbtype)

		const ctrlRef = this.$refs[formdataUtil_getCtrlRef(field)];
		// offsetParent - это значит невидимо, вот еще варики https://stackoverflow.com/a/33456469
		if (field.ctrlParams.ignoreHidden && ctrlRef && ctrlRef?.[0]?.$el?.offsetParent === null) {
			console.log(`Поле ${fieldName} исключено из отправки, т.к. имеет ignoreHidden и невидимо`);
			continue;
		}

		// ПО УМУ это должно быть внутри контролов, но есть препятствия, пока тут
		if (isFile) {
			// у одной колонки на странице может быть несколько контролов
			// эта функция ищет контрол типа file_upload и возвращает его значение
			// всегда массив, потому что в цикле
			const ctrlRef = this.$refs[formdataUtil_getCtrlRef(field)];
			if (!ctrlRef) {
				console.log('Не найден ref для поля ', field.dbcolname);
				continue;
			}
			const fileCtrl = ctrlRef[0];
			if (fileCtrl && !fileCtrl.c_ctrlParams.isReadOnly) {
				formData.addField(fieldName, fileCtrl.EXT_getFileFormdataObj());
			} else {
				console.log(
					`Вероятно, контрол на колонке ${fieldName} имеет признак isReadOnly. Игнорируем его при сборке объекта сабмита`,
				);
			}
		} else if (field.value instanceof Array) {
			// Поддерживаются значения контролов в виде
			// а) массива объектов [{id, name}]  --  такие массивы приводим к массиву айди, которые ожидает сервер
			if (field.value[0] && field.value[0].id) {
				for (let z = 0; z < field.value.length; z++) {
					formData.addField(fieldName, field.value[z].id);
				}
			}
			// б) массива айдишников [1,2,3]
			else {
				formData.addField(fieldName, field.value);
			}
		} else if (field.ctrlCode === 'text_static') {
			// данные статика не отправляем
		} else if (clientDbtype === 'NUMBER') {
			// if field.ctrlCode === 'popup_picker' || field.ctrlCode === 'dropdown'
			let numberValue;
			if (field.value && field.value.id) {
				// например если зайти в карточку и не править popup_picker, куда пришел {id,name}
				numberValue = field.value.id;
			} else {
				numberValue = isNaN(parseFloat(field.value)) ? null : parseFloat(field.value); // если значение числовое - возвращаем его, если нет - null (полезно для пустых строковых контролов)
			}

			formData.addField(fieldName, numberValue);
		} else if (field.value !== undefined) {
			/*else if (field.ctrlCode === 'mailing_init') {
			formData.addField('_mailing_init', field.value);
		}*/
			// андефайнед случается при создании записи
			formData.addField(fieldName, field.value);
		}

		// Для дочерних АРМ:
		if (opt.parentFieldData && opt.parentFieldData.name === field.dbcolname && field.value) {
			if (
				field.ctrlCode === 'text_static' &&
				field.ctrlParams.hasOwnProperty('isConst') &&
				field.ctrlParams.isConst === true
			) {
				// Добавляем если text_static и если есть ctrlParams['isConst']
			} else needToSetParentField = false; // колонка с айди родителя есть, а значит
		}
	}

	if (needToSetParentField && opt.parentFieldData && opt.parentFieldData.name && opt.parentFieldData.value) {
		formData.addField(opt.parentFieldData.name, opt.parentFieldData.value);
	} else if (this.$props.list_in_card && this.$props.item_target_column) {
		formData.addField(this.$props.item_target_column, this.$props.item_id);
	}

	return formData;
}

function ArmFormData({ armId, mode, recordId, armState }) {
	if (modeIsIllegal(mode)) {
		return;
	}
	const fData = new FormData();
	const recordFields = {}; // то что станет полем jsonPayload.records[0].fields

	// Добавление полей
	this.addField = function (key, value) {
		if (value && value.IS_FILE_UPLOAD === true) {
			// флаг-константа. Означает что value это специальный объект с файлом
			const isUploadingFile = value.FILE_PAYLOAD instanceof File; // на FileList не проверяю пока
			// четыре кейса:
			// 1. файл удаляем:
			if (value.IS_REMOVE === true) {
				recordFields[key] = null;
			}
			// 2. файл загружаем с его параметрами (ширина-высота-название):
			else if (isUploadingFile) {
				recordFields[key] = getFileCtrlValueWithoutServiceFields(value);
				// Поле внутри jsonPayload.records[0].fields[myFileField] содержит:
				// 1) formField - имя поля с самим файлом (которое будет рядом с jsonPayload)
				// 2) метаданные файла - имя, ширина-высота и проч. Имена этих полей совпадают с именами кот приезжают с сервера внутри value контрола загрузки файла
				const fileFieldName = `file_${Math.round(Math.random() * 1e7)}`;
				recordFields[key].formField = fileFieldName; // при удалении это поле также должно быть null PIRS2018-436
				fData.append(fileFieldName, value.FILE_PAYLOAD);
			}
			// 3. файл не загружаем, редактируем его параметры (он был загружен ранее) PIRS2018-329:
			else if (value.IS_PREVIOUSLY_UPLOADED === true) {
				recordFields[key] = getFileCtrlValueWithoutServiceFields(value);
			}
			// 4. файла не было и нет
			else {
			}
		} else if (recordFields[key]) {
			// если значение по ключу уже существует, значит оно должно быть массивом
			if (recordFields[key] instanceof Array) {
				// оно уже массив
				recordFields[key].push(value);
			} else {
				// оно еще не массив, делаем его массивом
				recordFields[key] = [recordFields[key], value];
			}
		} else {
			// простейший случай
			recordFields[key] = value;
		}
	};

	// Получение результата (объекта FormData)
	this.setPayloadAndGetFormData = function (opt) {
		fData.append('jsonPayload', JSON.stringify(this.getPayload(opt)));

		return fData;
	};

	this.getPayload = function () {
		const fields = [];
		for (const k in recordFields) {
			fields.push({
				fieldId: k,
				value: recordFields[k],
			});
		}
		// console.log(armState.armPathText);
		const record = {
			mode,
			armId,
			primaryKeyValue: recordId, // recordFields.id, // типа, необязательно выводить в поля АРМ ID
			fields,
			armState,
		};

		return {
			records: [record],
		};
	};
}

function getFileCtrlValueWithoutServiceFields(value) {
	return _.omit(value, 'FILE_PAYLOAD', 'IS_REMOVE', 'IS_FILE_UPLOAD', 'IS_PREVIOUSLY_UPLOADED'); // все служебные поля опускаем
}

// Опрашиваем контролы на валидность и возвращаем true если всё ОК
// Это метод инстанса Vue!
function formdataUtil_checkFieldList(fieldList) {
	if (fieldList instanceof Array === false) {
		throw new Error('Invalid fieldList', fieldList);
	}
	for (let i = 0; i < fieldList.length; i++) {
		const field = fieldList[i];
		if (!field) {
			// поля у которых нет контрола в текущем представлении (карточка или список) являются null
			continue;
		}

		const vm = this;
		const fieldRef = formdataUtil_getCtrlRef(field);

		// console.log(field.ctrlCode)
		const fieldCtrlRefs = this.$refs[fieldRef];
		if (!fieldCtrlRefs) {
			continue; // проверка потому что см. checkField в p_card.vue
		}
		const fieldCtrl = fieldCtrlRefs[0];

		if (fieldCtrl && fieldCtrl.VALIDATION_ERROR) {
			vm.$notify({
				type: 'error', // warn / error / success
				title: 'Ошибка валидации',
				text: `Некорректно заполнено поле «${field.name}»`,
			});
			console.log('Контрол невалиден ', field.dbcolname, fieldCtrl);

			return false;
		}

		const fieldNeedEmptyValidation =
			field.required &&
			!field.isFilterField && // в списке обязательность не проверяем
			!(field.ctrlCode === 'flag' && typeof field.value !== 'undefined') && // флаг в значении false и true валиден PIRS2018-223
			field.ctrlCode !== 'text_static'; // статику не валидируем

		if (fieldNeedEmptyValidation) {
			let fieldIsEmptyInvalid;
			if (field.ctrlCode === 'file_upload') {
				const fileCtrl = this.$refs[fieldRef][0];
				fieldIsEmptyInvalid = !fileCtrl.EXT_hasFile;
			} else if (field.ctrlCode === 'multiselect') {
				fieldIsEmptyInvalid = !field.value.length && field.value !== undefined; // в мультиселекте value - массив
			} else {
				fieldIsEmptyInvalid = !field.value && field.value !== 0; // ноль - валидное значение, например в числовой кол.
			}
			if (fieldIsEmptyInvalid) {
				vm.$notify({
					type: 'error', // warn / error / success
					title: 'Ошибка валидации',
					duration: -1,
					text: `Пожалуйста, заполните поле «${field.name}»`,
				});

				return false;
			}
		}
	}

	return true;
}

function formdataUtil_getCtrlRef(f) {
	return `ctrl_ref__${f.dbcolname}__${f.ctrlCode}`;
}

function modeIsIllegal(mode) {
	const correctModeValues = 'create/update/delete/upsert';
	if (correctModeValues.indexOf(mode) === -1) {
		console.error(`Illegal mode argument: ${mode}. Correct values are: ${correctModeValues}`);
	}
}

// Метод обработки сообщений об ошибках
function formdataUtil_renderError(errText) {
	if (!errText || typeof errText !== 'string') {
		return errText;
	}

	const duplicates = errText.match(/Detail: Key \((.*?)\)=\((.*?)\) already exists/);
	if (duplicates) {
		// PIRS-2-10995
		const [, keys, values] = duplicates;
		const [key1, key2 = ''] = keys.split(', ');
		const [value1, value2 = ''] = values.split(', ');

		if (key1 && value1) {
			const addition = key2 && value2 ? ` и <b>${key2} = ${value2}</b>` : '';

			return `Запись с <b>${key1} = ${value1}</b>${addition} уже существует!`;
		}
	}

	return errText;
}
